/*申报企业和推荐相关*/
import {apiRequest} from "@/api/api";

//----------------------------------------------注册界面

/*根据企业名称获取企业列表*/
export function getCompanyNames(config) {
   config.method = 'get'
   config.url = '/project/Company/getCompanyList'
   apiRequest(config)
}

/*获取社会信用代码*/
export function getTaxNumber(config) {
   config.method = 'get'
   config.url = '/project/Company/getTaxNumber'
   apiRequest(config)
}

/*企业注册信息提交*/
export function userRegister(config) {
   config.method = 'post'
   config.formData = true;
   config.url = '/project/Company/register'
   apiRequest(config)
}